import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { ModeType } from 'reactApp/ui/OverquotaPopup/newSplash/OverquotaSplash.types';

export const getModalName = (mode: ModeType | undefined) => {
    return mode === 'full_blocked' ? 'overquota_full_blocked' : 'overquota_splash_new';
};

export const renderOverquotaSplash = (data, onClose?: Parameters<typeof openPopupHelper>[0]['onClose']) =>
    openPopupHelper({ popupName: popupNames.OVERQUOTA_SPLASH, data, onClose });
